export default __webpack_public_path__ + "static/media/western_union_globe2.9c54ae8a.svg";